import { useNavigate } from "react-router-dom";
import { ChevronLeft, Trophy } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCustomerProfile } from "@/hooks/useLocal";
import Leaderboard from "@/components/games/Leaderboard";

// Unified hub: every arcade game's all-time board in one scannable view (Duck Hunt keeps its
// easy/normal/hard split inside its own board). Reuses the per-game Leaderboard component and the
// existing /api/games/leaderboard endpoint — no new scoring. Spot/Spin are win/prize games with no
// score board, so they're not listed here.
const GAMES = [
  { game: "snake", title: "Snake Dash" },
  { game: "block", title: "Block Puzzle" },
  { game: "race", title: "2D Car Race" },
  { game: "duck", title: "Duck Hunt" },
  { game: "candy", title: "Candy Match" },
];

export default function Leaderboards() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { profile } = useCustomerProfile();
  const phone = user?.phone || profile?.phone || "";

  return (
    <div className="mx-auto max-w-3xl space-y-5 py-4">
      <div className="flex items-center gap-2">
        <button onClick={() => navigate("/games")} className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-secondary"><ChevronLeft className="h-6 w-6" /></button>
        <h1 className="flex items-center gap-2 font-display text-2xl font-bold"><Trophy className="h-6 w-6 text-amber-500" /> Leaderboards</h1>
      </div>
      <p className="text-sm text-muted-foreground">Your best score in every game and who&apos;s on top.</p>
      <div className="grid gap-4 sm:grid-cols-2">
        {GAMES.map((g) => (
          <Leaderboard key={g.game} game={g.game} phone={phone} title={g.title} />
        ))}
      </div>
    </div>
  );
}
